import * as React from 'react';
const HistoricDebtRow = ({ value, formatDate, formatNumber }) => (React.createElement(React.Fragment, null, value.historicDebts
    .sort((a, b) => (a.date > b.date ? -1 : 1))
    .map((item, index) => (React.createElement("div", { className: "ReadReport__Table__Row", key: index },
    React.createElement("div", { className: "ReadReport__Table__Col" },
        React.createElement("p", { className: "Paragraph" }, item.debt.numberOfAJudgments)),
    React.createElement("div", { className: "ReadReport__Table__Col" },
        React.createElement("p", { className: "Paragraph" }, item.debt.numberOfEJudgments)),
    React.createElement("div", { className: "ReadReport__Table__Col" },
        React.createElement("p", { className: "Paragraph" }, formatNumber(item.debt.totalAEJudgements))),
    React.createElement("div", { className: "ReadReport__Table__Col" },
        React.createElement("p", { className: "Paragraph" }, formatDate(item.date, { year: 'numeric', month: 'numeric', day: 'numeric' }))))))));
export default HistoricDebtRow;
